import { useExperiments } from '@wix/fe-essentials-standalone';

import { EXPERIMENTS } from '../constants';

const useIsAnswerGenerationMediaMobileEnabled = () => {
  const { experiments } = useExperiments({ suspense: false, readOnly: true });
  return experiments.enabled(EXPERIMENTS.SPECS.ANSWER_GENERATION_MEDIA_MOBILE);
};

export default useIsAnswerGenerationMediaMobileEnabled;

